import { AVAILABLE_LISTING } from "../../pages/drafts/constants"

export const getAvailableListingFromType = (subscriptionType) => {
  return AVAILABLE_LISTING[subscriptionType]
};